import { ContractorType } from './ContractorType'
import { EditPersons } from './EditPersons'

export const PersonsStep = () => {
  return (
    <>
      <ContractorType />
      <EditPersons />
    </>
  )
}
